import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { getAdminRole } from '../../utils/roleHelper';
import { ADMIN_DOMAIN } from '../../config/domains';
import { auth } from '../../firebase.config';

const isAdminDomain = window.location.hostname === ADMIN_DOMAIN;

/**
 * Protects admin routes.
 * - Waits for Firebase Auth to rehydrate from IndexedDB before deciding.
 * - Requires both localStorage session markers AND an active Firebase Auth user.
 * - If `allowedRoles` is provided, only those roles can access the route.
 * - If the logged-in role is not in allowedRoles, redirects to dashboard.
 */
const AdminProtectedRoute = ({ children, allowedRoles }) => {
  const [authReady, setAuthReady] = useState(!!auth.currentUser);

  useEffect(() => {
    if (authReady) return;
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthReady(true);
    });
    return unsubscribe;
  }, [authReady]);

  const adminProfile = localStorage.getItem('UserProfileAdmin');
  const adminLoginStatus = localStorage.getItem('UserLoginStatusAdmin');

  // Wait for Firebase Auth to rehydrate from IndexedDB before deciding
  if (!authReady) {
    return <div className="loader-container"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
  }

  // Require both localStorage markers AND a live Firebase Auth session.
  if (!adminProfile || adminLoginStatus !== 'true' || !auth.currentUser) {
    return <Navigate to={isAdminDomain ? "/" : "/admin"} replace />;
  }

  // Role-based restriction
  if (allowedRoles && allowedRoles.length > 0) {
    const role = getAdminRole();
    if (!allowedRoles.includes(role)) {
      return <Navigate to={isAdminDomain ? "/dashboard" : "/admin/dashboard"} replace />;
    }
  }

  return children;
};

export default AdminProtectedRoute;
